<template>
  <div class="detail-wrap">
    <!-- <el-loading v-if="logLoding" fullscreen></el-loading> -->
    <el-collapse v-model="collapseActiveName" accordion>
      <el-collapse-item name="info">
        <template slot="title">
          <div
            style="display: flex; width: 100%; line-height: 30px; height: 30px"
            @click="handleCheckUserInfo()"
          >
            <div class="arrow-wrap">
              <img class="arrow" src="@/assets/img/arrow.svg" />
            </div>
            <div class="title">User Info</div>
            <div class="text-wrap">
              <div class="text-wrap__title">User ID:</div>
              <div class="text-wrap__content">{{ form.userId }}</div>
            </div>
            <div class="text-wrap">
              <div class="text-wrap__title">Channel:</div>
              <div
                class="text-wrap__content"
                :style="{
                  color: form.merchantFontColor,
                  background: form.merchantBgColor,
                  padding: '4px',
                  borderRadius: '4px',
                }"
              >
                {{ form.merchantName }}
              </div>
            </div>
          </div>
        </template>
        <div class="info-row">
          <div class="item-popover-type">
            <div class="info-row__item__title">User ID:</div>
            <div class="info-row__item__content">{{ form.userId }}</div>
          </div>
          <div class="item-popover-type">
            <div class="info-row__item__title">Channel:</div>
            <el-tooltip
              v-if="form.merchantRemark"
              class="item"
              effect="dark"
              :content="form.merchantRemark"
              placement="top"
            >
              <div
                class="info-row__item__content asc-color"
                :style="{
                  color: form.merchantFontColor,
                  background: form.merchantBgColor,
                }"
              >
                {{ form.merchantName }}
              </div>
            </el-tooltip>
            <div
              v-else
              class="info-row__item__content asc-color"
              :style="{
                color: form.merchantFontColor,
                background: form.merchantBgColor,
              }"
            >
              {{ form.merchantName }}
            </div>
          </div>
          <el-popover
            placement="bottom"
            v-model="popover.userLevel.visible"
            @after-leave="handlePopoverReset('userLevel')"
            class="item-popover"
          >
            <div class="info-row__item is-clickable" slot="reference">
              <div class="info-row__item__title">Level:</div>
              <div class="info-row__item__content content-level">
                <div v-if="form.userLevelName" class="tag">
                  {{ form.userLevelName }}
                </div>
              </div>
              <span v-if="form.userLevelExpire" style="color: #e13b3b"
                >(Expired)</span
              >
              <i class="el-icon-arrow-down" />
            </div>
            <div class="el-select-dropdown__wrap el-scrollbar__wrap">
              <div class="el-scrollbar__view el-select-dropdown__list">
                <div
                  v-for="item in levelList"
                  :key="item.id"
                  :class="[
                    popover.userLevel.selectedIds.includes(String(item.id))
                      ? 'is-selected'
                      : '',
                    'el-dropdown-menu__item',
                  ]"
                  @click="
                    handlePopoverOptionClick('userLevel', {
                      id: String(item.id),
                      name: item.name,
                    })
                  "
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div class="popover-buttons">
              <el-button type="text" @click="handlePopoverReset('userLevel')"
                >Cancel</el-button
              >
              <el-button
                type="primary"
                @click="handlePopoverSave('userLevel')"
                :disabled="isFetching"
                >Save</el-button
              >
            </div>
          </el-popover>
          <el-popover
            placement="bottom"
            v-model="popover.userLimit.visible"
            @after-leave="handlePopoverReset('userLimit')"
            class="item-popover"
          >
            <div class="info-row__item is-clickable" slot="reference">
              <div class="info-row__item__title">User Limit:</div>
              <div
                class="info-row__item__content content-level"
                style="display: flex; align-items: center"
              >
                <span class="odds-tag" v-if="form.levelSource === 2">C</span>
                <span
                  class="odds-tag"
                  v-if="
                    form.levelIdByFb &&
                    Number(form.levelIdByFb) !== Number(form.originalLevelId) &&
                    Number(form.levelSource) !== 2
                  "
                  >M</span
                >
                <div class="tag tag--border">
                  {{
                    form.userLevelId == 22 && form.levelSource == 2
                      ? form.merchantNewUserLevelName
                      : form.levelName
                  }}
                </div>
              </div>
              <i class="el-icon-arrow-down" />
            </div>
            <div class="el-select-dropdown__wrap el-scrollbar__wrap">
              <div class="el-scrollbar__view el-select-dropdown__list">
                <div
                  v-for="item in sortedArr"
                  :key="item.id"
                  :class="[
                    popover.userLimit.selectedIds.includes(item.id)
                      ? 'is-selected'
                      : '',
                    'el-dropdown-menu__item',
                  ]"
                  @click="
                    handlePopoverOptionClick('userLimit', {
                      id: item.id,
                      name: item.name,
                    })
                  "
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div class="popover-buttons">
              <el-button type="text" @click="handlePopoverReset('userLimit')"
                >Cancel</el-button
              >
              <el-button
                type="primary"
                @click="handlePopoverSave('userLimit')"
                :disabled="isFetching"
                >Save</el-button
              >
            </div>
          </el-popover>
          <el-popover
            placement="bottom"
            v-model="popover.oddsLevel.visible"
            @after-leave="handlePopoverReset('oddsLevel')"
            class="item-popover"
          >
            <div class="info-row__item is-clickable" slot="reference">
              <div class="info-row__item__title">Odds level:</div>
              <div class="info-row__item__content content-level">
                <div>
                  <span v-if="oddsTag" class="odds-tag">{{
                    this.oddsTag
                  }}</span>
                  <span
                    v-if="form.oddsLevelOperationService == '2'"
                    class="odds-tag"
                    >M</span
                  >
                  {{ form.oddsLevelName }}
                </div>
              </div>
              <i class="el-icon-arrow-down" />
            </div>
            <div class="el-select-dropdown__wrap el-scrollbar__wrap">
              <div class="el-scrollbar__view el-select-dropdown__list">
                <div
                  v-for="item in oddList"
                  :key="item.id"
                  :class="[
                    popover.oddsLevel.selectedIds.includes(item.id)
                      ? 'is-selected'
                      : '',
                    'el-dropdown-menu__item',
                  ]"
                  @click="
                    handlePopoverOptionClick('oddsLevel', {
                      id: item.id,
                      name: item.name,
                    })
                  "
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div class="popover-buttons">
              <el-button type="text" @click="handlePopoverReset('oddsLevel')"
                >Cancel</el-button
              >
              <el-button
                type="primary"
                @click="handlePopoverSave('oddsLevel')"
                :disabled="isFetching"
                >Save</el-button
              >
            </div>
          </el-popover>



          <el-popover
            placement="bottom"
            v-model="popover.marginOddsLevel.visible"
            @after-leave="handlePopoverReset('marginOddsLevel')"
            class="item-popover"
          >
            <div class="info-row__item is-clickable" slot="reference">
              <div class="info-row__item__title">Margin Odds level:</div>
              <div class="info-row__item__content content-level">
                <div>
                  <span v-if="marginOddsTag" class="odds-tag">{{
                    this.marginOddsTag
                  }}</span>
                  <span
                    v-if="form.marginOddsLevelOperationService == '2'"
                    class="odds-tag"
                    >M</span
                  >
                  {{ form.marginOddsLevelName }}
                </div>
              </div>
              <i class="el-icon-arrow-down" />
            </div>
            <div class="el-select-dropdown__wrap el-scrollbar__wrap">
              <div class="el-scrollbar__view el-select-dropdown__list">
                <div
                  v-for="item in oddList"
                  :key="item.id"
                  :class="[
                    popover.marginOddsLevel.selectedIds.includes(item.id)
                      ? 'is-selected'
                      : '',
                    'el-dropdown-menu__item',
                  ]"
                  @click="
                    handlePopoverOptionClick('marginOddsLevel', {
                      id: item.id,
                      name: item.name,
                    })
                  "
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div class="popover-buttons">
              <el-button type="text" @click="handlePopoverReset('marginOddsLevel')"
                >Cancel</el-button
              >
              <el-button
                type="primary"
                @click="handlePopoverSave('marginOddsLevel')"
                :disabled="isFetching"
                >Save</el-button
              >
            </div>
          </el-popover>



          <el-popover
            placement="bottom"
            v-model="popover.status.visible"
            @after-leave="handlePopoverReset('status')"
            class="item-popover"
          >
            <div class="info-row__item is-clickable" slot="reference">
              <div class="info-row__item__title">Status:</div>
              <div class="info-row__item__content content-level">
                <div
                  :class="[
                    'tag',
                    form.status === 0 ? 'tag--suspend' : '',
                    form.status === 1 ? 'tag--active' : '',
                    form.status === 2 ? 'tag--block' : '',
                  ]"
                >
                  {{ form.statusName }}
                </div>
              </div>
              <i class="el-icon-arrow-down" />
            </div>
            <div class="el-select-dropdown__wrap el-scrollbar__wrap">
              <div class="el-scrollbar__view el-select-dropdown__list">
                <div
                  v-for="item in statusList"
                  :key="item.id"
                  :class="[
                    popover.status.selectedIds.includes(item.id)
                      ? 'is-selected'
                      : '',
                    'el-dropdown-menu__item',
                  ]"
                  @click="
                    handlePopoverOptionClick('status', {
                      id: item.id,
                      name: item.name,
                    })
                  "
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div class="popover-buttons">
              <el-button type="text" @click="handlePopoverReset('status')"
                >Cancel</el-button
              >
              <el-button
                type="primary"
                @click="handlePopoverSave('status')"
                :disabled="isFetching"
                >Save</el-button
              >
            </div>
          </el-popover>
        </div>

        <div class="info-row" style="align-items: center">
          <div class="info-row__item">
            <el-tooltip
              class="item"
              effect="dark"
              :disabled="form.labelIds.length <= 0"
              :content="getLabelNames(form.labelIds)"
              placement="top"
            >
              <div class="info-row__item__title">Label:</div>
            </el-tooltip>
            <div class="info-row__item__content overflow-ellipsis">
              <el-tooltip
                v-for="(item, idx) in getLabelNames1(form.labelIds)"
                :key="item"
                class="item"
                effect="dark"
                :disabled="!getLabelDate(form.labelDetails, form.labelIds[idx])"
                :content="getLabelDate(form.labelDetails, form.labelIds[idx])"
                placement="top"
              >
                <span class="label-ids">{{ item }}</span>
              </el-tooltip>
            </div>
          </div>
          <!-- <div style="flex:1;;margin-right: 10px;height: 35px;">
            <el-popover
              placement="bottom"
              v-model="popover.label.visible"
              @after-leave="handlePopoverReset('label')"
              class="item-popover1"
            >
              <div class="info-row__item is-clickable" slot="reference" style="min-width: 555px">
                <div class="info-row__item__title">Label:</div>
                <div class="info-row__item__content">
                  <div class="tag-group">
                    <div
                      v-for="item in form.labels"
                      :key="item.id"
                      class="tag"
                    >{{ item.labelName || item.name }}</div>
                  </div>
                </div>
                <i class="el-icon-arrow-down" />
              </div>
              <div class="el-select-dropdown__wrap el-scrollbar__wrap">
                <div class="el-scrollbar__view el-select-dropdown__list">
                  <div
                    v-for="item in lableList"
                    :key="item.id"
                    :class="[
                      'el-dropdown-menu__item',
                      popover.label.selectedIds.includes(item.id)
                        ? 'is-selected'
                        : '',
                      popover.label.selectedIds.length >= 5 &&
                      !popover.label.selectedIds.includes(item.id)
                        ? 'is-disabled'
                        : ''
                    ]"
                    @click="
                      handlePopoverOptionClick(
                        'label',
                        {
                          id: item.id,
                          name: item.labelName
                        },
                        true,
                        popover.label.selectedIds.length >= 5 &&
                          !popover.label.selectedIds.includes(item.id)
                      )
                    "
                  >
                    <div>{{ item.labelName }}</div>
                    <i v-if="popover.label.selectedIds.includes(item.id)" class="el-icon-check" />
                  </div>
                </div>
              </div>
              <div class="popover-buttons">
                <el-button type="text" @click="handlePopoverReset('label')">Cancel</el-button>
                <el-button
                  type="primary"
                  @click="handlePopoverSave('label')"
                  :disabled="isFetching"
                >Save</el-button>
              </div>
            </el-popover>
          </div>-->
          <div style="flex: 1.6; display: flex">
            <div class="item-popover-type1">
              <div class="info-row__item__title">Self-Risk:</div>
              <div class="info-row__item__content is-text-switch">
                <div class="switch-wrap" @click="openMessageBox('selfRisk')">
                  <el-switch
                    v-model="selfRisk"
                    :active-value="1"
                    :inactive-value="0"
                    :width="48"
                    active-color="#00A791"
                    inactive-color="#D5D9E0"
                  />
                </div>
              </div>
            </div>
            <div class="item-popover-type1">
              <div class="info-row__item__title">Delay Settle:</div>
              <div class="info-row__item__content is-text-switch">
                <div class="switch-wrap" @click="openMessageBox('delaySettled')">
                  <el-switch
                    v-model="delaySettled"
                    :active-value="1"
                    :inactive-value="0"
                    :width="48"
                    active-color="#00A791"
                    inactive-color="#D5D9E0"
                  />
                </div>
              </div>
            </div>
            <!-- <div class="info-row__item" style="min-width: 143px">
            <div class="info-row__item__title">Alert:</div>
            <div class="info-row__item__content">
              <div class="switch-wrap" @click="openMessageBox('isAlert')">
                <el-switch
                  v-model="isAlert"
                  :active-value="true"
                  :inactive-value="false"
                  :width="40"
                  active-color="#00A791"
                  inactive-color="#D5D9E0"
                />
              </div>
            </div>
            </div>-->
            <el-popover
              placement="bottom"
              v-model="popover.oddsDrop.visible"
              @after-leave="handlePopoverReset('oddsDrop')"
              class="item-popover"
              style="flex: 2"
            >
              <div class="info-row__item is-clickable" slot="reference">
                <div class="info-row__item__title">odds Drop Template:</div>
                <div class="info-row__item__content content-level">
                  <div class="tag">{{ form.oddsDropFactorName }}</div>
                </div>
                <i class="el-icon-arrow-down" />
              </div>
              <div class="el-select-dropdown__wrap el-scrollbar__wrap">
                <div class="el-scrollbar__view el-select-dropdown__list">
                  <div
                    v-for="item in oddsDropFactorList"
                    :key="Number(item.id)"
                    :class="[
                      popover.oddsDrop.selectedIds.includes(Number(item.id))
                        ? 'is-selected'
                        : '',
                      'el-dropdown-menu__item',
                    ]"
                    @click="
                      handlePopoverOptionClick('oddsDrop', {
                        id: Number(item.id),
                        name: item.name,
                      })
                    "
                  >
                    {{ item.name }}
                  </div>
                </div>
              </div>
              <div class="popover-buttons">
                <el-button type="text" @click="handlePopoverReset('oddsDrop')"
                  >Cancel</el-button
                >
                <el-button
                  type="primary"
                  @click="handlePopoverSave('oddsDrop')"
                  :disabled="isFetching"
                  >Save</el-button
                >
              </div>
            </el-popover>
            <el-popover
              placement="bottom"
              v-model="popover.delayedOrder.visible"
              @after-leave="handlePopoverReset('delayedOrder')"
              class="item-popover"
            >
              <div class="info-row__item is-clickable" slot="reference">
                <div class="info-row__item__title">Delayed Order:</div>
                <div class="info-row__item__content content-level">
                  <div v-if="form.baseDelayedName" class="tag">{{ form.baseDelayedName }}</div>
                </div>
                <i class="el-icon-arrow-down" />
              </div>
              <div class="el-select-dropdown__wrap el-scrollbar__wrap">
                <div class="el-scrollbar__view el-select-dropdown__list">
                  <div
                    v-for="item in delayedOrderList"
                    :key="item.id"
                    :class="[
                      popover.delayedOrder.selectedIds.includes(
                        Number(item.id)
                      )
                        ? 'is-selected'
                        : '',
                      'el-dropdown-menu__item',
                    ]"
                    @click="
                      handlePopoverOptionClick('delayedOrder', {
                        id: Number(item.id),
                        name: item.name,
                      })
                    "
                  >
                    {{ item.name }}
                  </div>
                </div>
              </div>
              <div class="popover-buttons">
                <el-button
                  type="text"
                  @click="handlePopoverReset('delayedOrder')"
                  >Cancel</el-button
                >
                <el-button
                  type="primary"
                  @click="handlePopoverSave('delayedOrder')"
                  :disabled="isFetching"
                  >Save</el-button
                >
              </div>
            </el-popover>
            <el-popover
              placement="bottom"
              v-model="popover.suspendBetting.visible"
              @after-leave="handlePopoverReset('suspendBetting')"
              class="item-popover"
            >
              <div class="info-row__item is-clickable" slot="reference">
                <div class="info-row__item__title">suspend Betting Factor:</div>
                <div class="info-row__item__content content-level">
                  <div class="tag">{{ form.suspendBettingFactorName }}</div>
                </div>
                <i class="el-icon-arrow-down" />
              </div>
              <div class="el-select-dropdown__wrap el-scrollbar__wrap">
                <div class="el-scrollbar__view el-select-dropdown__list">
                  <div
                    v-for="item in suspendBettingFactorList"
                    :key="item.id"
                    :class="[
                      popover.suspendBetting.selectedIds.includes(
                        Number(item.id)
                      )
                        ? 'is-selected'
                        : '',
                      'el-dropdown-menu__item',
                    ]"
                    @click="
                      handlePopoverOptionClick('suspendBetting', {
                        id: Number(item.id),
                        name: item.name,
                      })
                    "
                  >
                    {{ item.name }}
                  </div>
                </div>
              </div>
              <div class="popover-buttons">
                <el-button
                  type="text"
                  @click="handlePopoverReset('suspendBetting')"
                  >Cancel</el-button
                >
                <el-button
                  type="primary"
                  @click="handlePopoverSave('suspendBetting')"
                  :disabled="isFetching"
                  >Save</el-button
                >
              </div>
            </el-popover>
          </div>
        </div>
        <div class="info-row">
          <div class="info-row__item" style="min-width: calc(16.67% - 30px)">
            <div class="info-row__item__title">Regist Time:</div>
            <div class="info-row__item__content">
              {{ formatUtc(basicInfo.registrationTime) }}
            </div>
          </div>
          <div class="info-row__item" style="min-width: calc(16.67% - 30px)">
            <div class="info-row__item__title">Regist IP:</div>
            <div class="info-row__item__content">
              {{ basicInfo.registrationIP }}
            </div>
          </div>
          <div class="info-row__item" style="min-width: calc(16.66% - 30px)">
            <div class="info-row__item__title">Regist Region:</div>
            <div class="info-row__item__content">
              {{ basicInfo.registrationRegion }}
            </div>
          </div>
          <!-- <div class="info-row__item" style="min-width: calc(16.66% - 30px)">
            <div class="info-row__item__title">Last login time:</div>
            <div class="info-row__item__content">{{ formatUtc(basicInfo.lastLoginTime) }}</div>
          </div>-->
          <div class="info-row__item" style="min-width: calc(16.66% - 30px)">
            <div class="info-row__item__title">Last Bet time:</div>
            <div class="info-row__item__content">
              {{ formatUtc(basicInfo.lastBetTime) }}
            </div>
          </div>
          <div class="info-row__item" style="min-width: calc(16.66% - 20px)">
            <div class="info-row__item__title">Level Update Time:</div>
            <div class="info-row__item__content">
              {{ formatUtc(basicInfo.userLevelUpdateTime) }}
            </div>
          </div>
        </div>
        <!-- <div class="info-row">
          <div class="remark">
            <div class="remark__title">Remark:</div>
            <el-input
              type="textarea"
              maxlength="240"
              resize="none"
              show-word-limit
              :rows="4"
              placeholder="Please input"
              v-model="remark"
            />
            <div class="remark__buttons">
              <el-button type="primary" @click="handleRemarkSave">
                Save
              </el-button>
              <el-button type="text" @click="handleRemarkReset">
                Cancel
              </el-button>
            </div>
          </div>
        </div>-->
      </el-collapse-item>
    </el-collapse>
    <el-collapse
      v-model="collapseActiveRemark"
      accordion
      style="margin-top: 10px"
    >
      <el-collapse-item name="remark">
        <template slot="title">
          <div @click="handleCheckHistory()" style="display: flex; width: 100%">
            <div class="arrow-wrap" style="top: 15px">
              <img class="arrow" src="@/assets/img/arrow.svg" />
            </div>
            <div class="remark-box">
              <div class="title">
                <span>Check History</span>
                <span v-if="tips" class="tips"
                  >{{ formatUtc(tipsTime) }} {{ tips }}</span
                >
              </div>
              <div>
                <el-button
                  type="primary"
                  class="search-btn"
                  @click.stop.prevent="handleCheck()"
                  >Check</el-button
                >
              </div>
            </div>
          </div>
        </template>
        <div style="padding: 0 10px">
          <CheckHistory
            :getModifyLogListArr="getModifyLogList"
            @api-call-success="handleApiCallSuccess"
            :logLoding="logLoding"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="tab-wrap">
      <el-tabs
        type="card"
        v-model="activeName"
        @tab-click="handleClick"
        id="line-tabs"
      >
        <el-tab-pane label="Betting Info" name="1"></el-tab-pane>
        <el-tab-pane label="Order List" name="2"></el-tab-pane>
        <el-tab-pane label="Login Log" name="3"></el-tab-pane>
        <el-tab-pane label="Modify History" name="4"></el-tab-pane>
        <!-- <el-tab-pane label="Check History" name="5"></el-tab-pane> -->
        <el-tab-pane label="IP History" name="6"></el-tab-pane>
        <el-tab-pane label="Device ID History" name="7"></el-tab-pane>
        <el-tab-pane label="Promotions Detail" name="8"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="container-content">
      <BettingInfo
        v-if="activeName == 1"
        @changeActiveName="changeActiveName"
        :handleCheckHistoryStatus="handleCheckHistoryStatus"
        :handleCheckUserInfoStatus="handleCheckUserInfoStatus"
      />
      <OrderList
        v-if="activeName == 2"
        :row="row"
        :endTime="endTime"
        :startTime="startTime"
        :handleCheckHistoryStatus="handleCheckHistoryStatus"
        :handleCheckUserInfoStatus="handleCheckUserInfoStatus"
      />
      <LoginLog
        v-if="activeName == 3"
        :handleCheckHistoryStatus="handleCheckHistoryStatus"
        :handleCheckUserInfoStatus="handleCheckUserInfoStatus"
      />
      <ModifyHistory
        v-if="activeName == 4"
        :handleCheckHistoryStatus="handleCheckHistoryStatus"
        :handleCheckUserInfoStatus="handleCheckUserInfoStatus"
      />
      <!-- <CheckHistory v-if="activeName == 5" /> -->
      <IPHistory
        v-if="activeName == 6"
        :handleCheckHistoryStatus="handleCheckHistoryStatus"
        :handleCheckUserInfoStatus="handleCheckUserInfoStatus"
      />
      <DeviceHistory
        v-if="activeName == 7"
        :handleCheckHistoryStatus="handleCheckHistoryStatus"
        :handleCheckUserInfoStatus="handleCheckUserInfoStatus"
      />
      <promotionsDetail 
        v-if="activeName == 8"
        :handleCheckHistoryStatus="handleCheckHistoryStatus"
        :handleCheckUserInfoStatus="handleCheckUserInfoStatus"
        :promotionConfigs="promotionConfigs"
      />
    </div>
    <dia ref="dialogDom" class="label-dialog">
      <div>
        <el-form :model="formRemark" label-width="156px">
          <el-form-item label="Remark">
            <el-input
              style="
                border: 1px solid #ebedf3;
                border-radius: 4px;
                height: 200px;
              "
              type="textarea"
              maxlength="240"
              resize="none"
              show-word-limit
              :rows="4"
              placeholder="Please input"
              v-model="formRemark.remark"
            />
          </el-form-item>
        </el-form>
        <div class="dialog-footer table-search-part">
          <el-button
            class="search-btn"
            @click="handleRemarkSave()"
            :disabled="isFetching"
            >Confirm</el-button
          >
          <el-button class="clear-btn" @click="Close()">Cancel</el-button>
        </div>
      </div>
    </dia>
  </div>
</template>

<script>
import dia from "@/components/dialog/index";
import BettingInfo from "@/views/member/memberDetail/components/bettingInfo";
import OrderList from "@/views/member/memberDetail/components/orderList";
import LoginLog from "@/views/member/memberDetail/components/loginLog";
import ModifyHistory from "@/views/member/memberDetail/components/modifyLog";
import CheckHistory from "@/views/member/memberDetail/components/checkHistory";
import IPHistory from "@/views/member/memberDetail/components/ipHistory";
import DeviceHistory from "@/views/member/memberDetail/components/deviceHistory";
import PromotionsDetail from "@/views/member/memberDetail/components/promotionsDetail.vue";
import {
  getMemberDetails,
  getLevelList,
  getRiskLevel,
  getMemberUpdate,
} from "@/api/member";
import { getBasicInfo, getModifyLog } from "@/api/memberDetail";
import { getRiskDetailsList } from "@/api/risk";
import { findAllLabel } from "@/api/lable";
import { oddsDropList } from "@/api/oddsDrop";


export default {
  name: "MemberDetail",
  data() {
    return {
      form: {
        userId: "",
        merchantName: "",
        levelId: "",
        levelName: "",
        levelSource: "",
        merchantNewUserLevelName: "",
        originalLevelId: "",
        levelIdByFb: "",
        userLevelId: "",
        userLevelName: "",
        userLevelExpire: false,
        isAlert: false,
        status: "",
        statusName: "",
        oddsLevel: "",
        marginOddsLevel: "",
        oddsDropFactor: "",
        oddsDropFactorName: "",
        suspendBettingFactor: "",
        suspendBettingFactorName: "",
        oddsLevelName: "",
        marginOddsLevelName: "",
        lastLoginTimeText: "",
        merchantBgColor: "",
        oddsLevelOperationService: "",
        marginOddsLevelOperationService: "",
        merchantFontColor: "",
        remark: "",
        merchantRemark: "",
        labelIds: [],
        labels: [],
        selfRisk: 0,
        delaySettled: 0,
        labelDetails: [],
        baseDelayed: "",
        baseDelayedName: ""
      },
      getModifyLogList: [],
      logLoding: false,
      isFetching: false, // 标记当前是否正在调用接口
      formRemark: {},
      basicInfo: {},
      oddList: [
        { id: 0, name: "Config" },
        { id: 1, name: "A" },
        { id: 2, name: "B" },
        { id: 3, name: "C" },
        { id: 4, name: "D" },
        { id: 5, name: "E" },
        { id: 6, name: "F" },
        { id: 7, name: "G" },
      ],
      statusList: [
        {
          id: 1,
          name: "Active",
        },
        {
          id: 0,
          name: "Suspend",
        },
        {
          id: 2,
          name: "Block",
        },
      ],
      tips: "",
      tipsTime: "",
      remark: "",
      list: [],
      loading: false,
      queryData: {
        riskLevelId: "",
        userId: "",
      },
      oddsTag: "",
      marginOddsTag: "",
      levelList: [],
      handleCheckHistoryStatus: false,
      handleCheckUserInfoStatus: false,
      lableList: [],
      riskLevelList: [],
      oddsDropFactorList: [],
      suspendBettingFactorList: [
        { id: "0", name: "0" },
        { id: "1", name: "1" },
        { id: "2", name: "2" },
        { id: "3", name: "3" },
        { id: "4", name: "4" },
      ],
      delayedOrderList:[
        {id:'0', name:'0'},
        {id:'6', name:'6s'},
        {id:'9', name:'9s'},
        {id:'12', name:'12s'},
        {id:'15', name:'15s'},
        {id:'20', name:'20s'},
        {id:'25', name:'25s'},
        {id:'30', name:'30s'},
      ],
      activeName: "1",
      row: {},
      startTime: "",
      endTime: "",
      popover: {
        userLevel: {
          visible: false,
          selectedIds: [],
          selectedItems: [],
        },
        label: {
          visible: false,
          selectedIds: [],
          selectedItems: [],
        },
        userLimit: {
          visible: false,
          selectedIds: [],
          selectedItems: [],
        },
        oddsLevel: {
          visible: false,
          selectedIds: [],
          selectedItems: [],
        },
        marginOddsLevel: {
          visible: false,
          selectedIds: [],
          selectedItems: [],
        },
        oddsDrop: {
          visible: false,
          selectedIds: [],
          selectedItems: [],
        },
        suspendBetting: {
          visible: false,
          selectedIds: [],
          selectedItems: [],
        },
        status: {
          visible: false,
          selectedIds: [],
          selectedItems: [],
        },
        delayedOrder: {
          visible: false,
          selectedIds: [],
          selectedItems: [],
        },
      },
      promotionConfigs: [],
      selfRisk: 0,
      delaySettled: 0,
      isAlert: false,
      collapseActiveName: "info",
      collapseActiveRemark: "remark",
    };
  },
  methods: {
    handleApiCallSuccess() {
      this.getModifyLog();
    },
    formatUtc(time) {
      return time ? this.$moment(+time).format("YYYY-MM-DD HH:mm:ss") : "";
    },
    getLabelDate(labelDetails, labelId) {
      if (labelDetails && labelDetails.length) {
        let time = labelDetails.find((item) => item.id == labelId)?.updateTime || '';
        return time ? this.$moment(+time).format("YYYY-MM-DD HH:mm:ss") : "";
      }
      return '';
    },
    getLabelNames(labelIds) {
      let labelArr = labelIds ? labelIds : [];
      let IdsArr = labelArr.map((i) => {
        return i;
      });
      let str = "";
      this.lableList.map((item) => {
        if (IdsArr.includes(item.labelId)) {
          str += item.labelName;
          str += "、";
        }
      });
      str = str.slice(0, -1); // 移除最后一个逗号
      return str;
    },
    getLabelNames1(labelIds) {
      let labelArr = labelIds ? labelIds : [];
      let IdsArr = labelArr.map((i) => {
        return i;
      });
      let labelNames = [];
      this.lableList.map((item) => {
        if (IdsArr.includes(item.labelId)) {
          labelNames.push(item.labelName);
        }
      });
      return labelNames;
    },
    async getRiskLevel() {
      const res = await getRiskLevel();
      let data = res.data || {};
      this.riskLevelList = this.getArray(data);
    },
    async oddsDropList() {
      const res = await oddsDropList();
      let data = res.data || {};
      this.oddsDropFactorList = data;
    },
    getArray(data) {
      return Object.keys(data).map((el) => {
        return {
          id: el,
          name: data[el],
        };
      });
      // const array = Object.keys(data).map(el => {
      //   return {
      //     id: el,
      //     name: data[el]
      //   };
      // });
      // array.push({
      //   id: "0",
      //   name: "Config"
      // });
      // return array;
    },
    async getLevelList() {
      const res = await getLevelList({});
      let data = res.data || [];
      const newItem = { id: 0, name: "Blank" };
      data.unshift(newItem);
      this.levelList = data;
    },
    async getLableList() {
      const res = await findAllLabel();
      let data = res.data || {};
      this.lableList = data;
    },
    handlePopoverOptionClick(
      key,
      option,
      isMultiple = false,
      isDisabled = false
    ) {
      if (isMultiple) {
        if (isDisabled) return;
        if (this.popover[key].selectedIds.includes(option.id)) {
          this.popover[key].selectedItems = this.popover[
            key
          ].selectedItems.filter((item) => item.id !== option.id);
          this.popover[key].selectedIds = this.popover[key].selectedIds.filter(
            (v) => v !== option.id
          );
          return;
        }
        this.popover[key].selectedItems.push(option);
        this.popover[key].selectedIds.push(option.id);
      } else {
        this.popover[key].selectedItems.splice(0);
        this.popover[key].selectedItems.push(option);
        this.popover[key].selectedIds.splice(0);
        this.popover[key].selectedIds.push(option.id);
      }
    },
    handleCheck(data) {
      this.title = "Add Remark";
      this.$refs["dialogDom"].isShowDia(this.title, true, "800px");
    },
    handleCheckHistory() {
      this.handleCheckHistoryStatus = !this.handleCheckHistoryStatus;
    },
    handleCheckUserInfo() {
      this.handleCheckUserInfoStatus = !this.handleCheckUserInfoStatus;
    },
    Close() {
      this.$refs["dialogDom"].isShowDia(this.title, false, "800px");
    },
    handlePopoverReset(key) {
      this.popover[key].visible = false;
      this.popover[key].selectedIds.splice(0);
      this.popover[key].selectedItems.splice(0);
      switch (key) {
        case "userLevel":
          this.popover[key].selectedIds.push(this.form.userLevelId);
          this.popover[key].selectedItems.push({
            id: this.form.userLevelId,
            name: this.form.userLevelName,
          });
          break;
        case "label":
          this.popover[key].selectedIds = this.form.labels.map(
            (item) => item.id
          );
          this.popover[key].selectedItems = [...this.form.labels];
          break;
        case "userLimit":
          this.popover[key].selectedIds.push(this.form.levelId);
          this.popover[key].selectedItems.push({
            id: this.form.levelId,
            name: this.form.levelName,
          });
        case "oddsLevel":
          this.popover[key].selectedIds.push(this.form.oddsLevel);
          this.popover[key].selectedItems.push({
            id: this.form.oddsLevel,
            name: this.form.oddsLevelName,
          });
        case "marginOddsLevel":
          this.popover[key].selectedIds.push(this.form.marginOddsLevel);
          this.popover[key].selectedItems.push({
            id: this.form.marginOddsLevel,
            name: this.form.marginOddsLevelName,
          });
        case "oddsDrop":
          this.popover[key].selectedIds.push(this.form.oddsDropFactor);
          this.popover[key].selectedItems.push({
            id: this.form.oddsDropFactor,
            name: this.form.oddsDropFactorName,
          });
        case "suspendBetting":
          this.popover[key].selectedIds.push(this.form.suspendBettingFactor);
          this.popover[key].selectedItems.push({
            id: this.form.suspendBettingFactor,
            name: this.form.suspendBettingFactorName,
          });
        case "status":
          this.popover[key].selectedIds.push(this.form.status);
          this.popover[key].selectedItems.push({
            id: this.form.status,
            name: this.form.statusName,
          });
        case "delayedOrder":
          this.popover[key].selectedIds.push(this.form.baseDelayed);
          this.popover[key].selectedItems.push({
            id: this.form.baseDelayed,
            name: this.form.baseDelayedName,
          });
        default:
          break;
      }
    },
    handlePopoverSave(key) {
      let payload = {};
      switch (key) {
        case "userLevel":
          this.form.userLevelId = this.popover[key].selectedIds[0];
          this.form.userLevelName = this.popover[key].selectedItems[0].name;
          payload = { userLevelId: this.form.userLevelId };
          break;
        case "oddsDrop":
          this.form.oddsDropFactor = this.popover[key].selectedIds[0];
          this.form.oddsDropFactorName =
            this.popover[key].selectedItems[0].name;
          payload = { oddsDropFactor: this.form.oddsDropFactor };
          break;
        case "suspendBetting":
          this.form.suspendBettingFactor = this.popover[key].selectedIds[0];
          this.form.suspendBettingFactorName =
            this.popover[key].selectedItems[0].name;
          payload = { suspendBettingFactor: this.form.suspendBettingFactor };
          break;
        case "label":
          this.form.labelIds = [...this.popover[key].selectedIds];
          this.form.labels = [...this.popover[key].selectedItems];
          payload = { labelIds: this.form.labelIds };
          break;
        case "userLimit":
          this.form.levelId = this.popover[key].selectedIds[0];
          this.form.levelName = this.popover[key].selectedItems[0].name;
          payload = { levelId: this.form.levelId };
          break;
        case "oddsLevel":
          this.form.oddsLevel = this.popover[key].selectedIds[0];
          this.form.oddsLevelName = this.popover[key].selectedItems[0].name;
          payload = { oddsLevel: this.form.oddsLevel };
          break;
        case "marginOddsLevel":
          this.form.marginOddsLevel = this.popover[key].selectedIds[0];
          this.form.marginOddsLevelName = this.popover[key].selectedItems[0].name;
          payload = { marginOddsLevel: this.form.marginOddsLevel };
          break;
        case "status":
          this.form.status = this.popover[key].selectedIds[0];
          this.form.statusName = this.popover[key].selectedItems[0].name;
          payload = { status: this.form.status };
          break;
        case "delayedOrder":
          this.form.baseDelayed = this.popover[key].selectedIds[0];
          this.form.baseDelayedName = this.popover[key].selectedItems[0].name;
          payload = { baseDelayed: this.form.baseDelayed };
          break;
          
        default:
          break;
      }
      this.handleSave(payload);
      this.popover[key].visible = false;
      this.popover[key].selectedIds.splice(0);
      this.popover[key].selectedItems.splice(0);
    },
    async getList() {
      this.loading = true;
      try {
        const res = await getRiskDetailsList(this.queryData);
        const data = res.data || {};
        this.list = [data] || [];
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    async getBasicInfo() {
      try {
        const res = await getBasicInfo(this.queryData);
        const data = res.data || {};
        this.basicInfo = res.data;
      } catch (error) {
        this.basicInfo = {};
      }
    },
    async getDetail() {
      this.loading = true;
      try {
        const res = await getMemberDetails(this.queryData);
        const data = res.data || {}

        this.promotionConfigs = data.promotionConfigs
        this.form.userId = data.userId;
        this.form.merchantName = data.merchantName;
        this.form.remark = data.remark;
        this.form.merchantRemark = data.merchantRemark;
        this.form.merchantBgColor = data.merchantBgColor;
        this.form.oddsLevelOperationService = data.oddsLevelOperationService;
        this.form.marginOddsLevelOperationService = data.marginOddsLevelOperationService
        this.form.merchantFontColor = data.merchantFontColor;
        this.form.levelId = data.levelId;
        this.popover.userLimit.selectedIds.splice(0);
        this.popover.userLimit.selectedItems.splice(0);
        this.popover.userLimit.selectedIds.push(data.levelId);
        this.popover.userLimit.selectedItems.push({
          id: data.levelId,
          name: data.levelName,
        });
        this.queryData.riskLevelId = data.levelId;
        this.form.levelName = data.levelName;
        this.form.levelSource = data.levelSource;
        this.form.merchantNewUserLevelName = data.merchantNewUserLevelName;
        this.form.originalLevelId = data.originalLevelId;
        this.form.levelIdByFb = data.levelIdByFb;
        this.form.userLevelId = data.userLevelId;
        this.form.userLevelName = data.userLevelName;
        this.form.userLevelExpire = data.userLevelExpire;
        this.form.labelDetails = data.labelDetails;
        this.popover.userLevel.selectedIds.splice(0);
        this.popover.userLevel.selectedItems.splice(0);
        this.popover.userLevel.selectedIds.push(data.userLevelId);
        this.popover.userLevel.selectedItems.push({
          id: data.userLevelId,
          name: data.userLevelName,
        });

        this.form.oddsDropFactor = data.oddsDropFactor;
        this.form.oddsDropFactorName = data.oddsDropGroupName;
        this.popover.oddsDrop.selectedIds.splice(0);
        this.popover.oddsDrop.selectedItems.splice(0);
        this.popover.oddsDrop.selectedIds.push(data.oddsDropFactor);
        this.popover.oddsDrop.selectedItems.push({
          id: data.oddsDropFactor,
          name: data.oddsDropFactor,
        });
        this.form.suspendBettingFactor = data.suspendBettingFactor;
        this.form.suspendBettingFactorName = data.suspendBettingFactor;
        this.popover.suspendBetting.selectedIds.splice(0);
        this.popover.suspendBetting.selectedItems.splice(0);
        this.popover.suspendBetting.selectedIds.push(data.suspendBettingFactor);
        this.popover.suspendBetting.selectedItems.push({
          id: data.suspendBettingFactor,
          name: data.suspendBettingFactor,
        });
        this.form.status = data.status;
        this.form.statusName = this.statusList.find(
          (item) => item.id === data.status
        ).name;
        this.popover.status.selectedIds.splice(0);
        this.popover.status.selectedItems.splice(0);
        this.popover.status.selectedIds.push(data.status);
        this.popover.status.selectedItems = this.statusList.map(
          (item) => item.id === data.status
        );
        this.popover.delayedOrder.selectedIds.splice(0);
        this.popover.delayedOrder.selectedItems.splice(0);
        this.popover.delayedOrder.selectedIds.push(data.baseDelayed);
        this.popover.delayedOrder.selectedItems = this.delayedOrderList.map(
          (item) => item.id == data.baseDelayed
        );
        this.form.baseDelayed = data.baseDelayed;
        let baseVal = this.delayedOrderList.find(item => item.id == data.baseDelayed)
        if(baseVal){
          this.form.baseDelayedName = baseVal.name
        }
        this.form.isAlert = data.isAlert;
        this.isAlert = data.isAlert;
        this.form.oddsLevel = data.oddsLevel;
        this.form.marginOddsLevel = data.marginOddsLevel;

        if (data.oddsLevelSource === 3) {
          const oddsLevelName = this.oddList.find(
            (item) => item.id === data.oddsLevel
          ).name;
          this.oddsTag = "C";
          this.form.oddsLevelName = oddsLevelName;
        } else if (data.oddsLevelSource === 1) {
          this.form.oddsLevelName = this.oddList.find(
            (item) => item.id === data.oddsLevel
          ).name;
          this.oddsTag = "";
        } else {
          const oddsLevelName = this.oddList.find(
            (item) => item.id === data.oddsLevel
          ).name;
          this.oddsTag = "L";
          this.form.oddsLevelName = oddsLevelName;
        }

        if (data.marginOddsLevelSource === 3) {
          const marginOddsLevelName = this.oddList.find(
            (item) => item.id === data.marginOddsLevel
          ).name;
          this.marginOddsTag = "C";
          this.form.marginOddsLevelName = marginOddsLevelName;
        } else if (data.marginOddsLevelSource === 1) {
          this.form.marginOddsLevelName = this.oddList.find(
            (item) => item.id === data.marginOddsLevel
          ).name;
          this.marginOddsTag = "";
        } else {
          const marginOddsLevelName = this.oddList.find(
            (item) => item.id === data.marginOddsLevel
          ).name;
          this.marginOddsTag = "L";
          this.form.marginOddsLevelName = marginOddsLevelName;
        }

        this.popover.oddsLevel.selectedIds.splice(0);
        this.popover.oddsLevel.selectedItems.splice(0);
        if (data.oddsLevelSource === 3) {
          this.popover.oddsLevel.selectedIds.push(0); // Channel Config
          this.popover.oddsLevel.selectedItems = this.oddList.map(
            (item) => item.id === 0
          );
        } else if (data.oddsLevelSource === 1) {
          this.popover.oddsLevel.selectedIds.push(this.form.oddsLevel);
          this.popover.oddsLevel.selectedItems = this.oddList.map(
            (item) => item.id === this.form.oddsLevel
          );
        } else {
          this.popover.oddsLevel.selectedIds.push(0); // level Config
          this.popover.oddsLevel.selectedItems = this.oddList.map(
            (item) => item.id === 0
          );
        }

        this.popover.marginOddsLevel.selectedIds.splice(0);
        this.popover.marginOddsLevel.selectedItems.splice(0);
        if (data.marginOddsLevelSource === 3) {
          this.popover.marginOddsLevel.selectedIds.push(0); // Channel Config
          this.popover.marginOddsLevel.selectedItems = this.oddList.map(
            (item) => item.id === 0
          );
        } else if (data.marginOddsLevelSource === 1) {
          this.popover.marginOddsLevel.selectedIds.push(this.form.marginOddsLevel);
          this.popover.marginOddsLevel.selectedItems = this.oddList.map(
            (item) => item.id === this.form.marginOddsLevel
          );
        } else {
          this.popover.marginOddsLevel.selectedIds.push(0); // level Config
          this.popover.marginOddsLevel.selectedItems = this.oddList.map(
            (item) => item.id === 0
          );
        }

        this.remark = data.remark;
        this.form.remark = data.remark;
        this.form.merchantRemark = data.merchantRemark;
        this.form.lastLoginTimeText = data.lastLoginTimeText;

        this.form.labelIds = data.labelIds;
        // this.form.labels = [...data.labelList];
        // this.popover.label.selectedIds.splice(0);
        // this.popover.label.selectedItems.splice(0);
        // this.popover.label.selectedItems = [...data.labelList];
        // this.popover.label.selectedIds = data.labelList.map(item => item.id);
        this.form.selfRisk = data.selfRisk;
        this.selfRisk = data.selfRisk;
        this.form.delaySettled = data.delaySettled;
        this.delaySettled = data.delaySettled;
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    handleClick() {
      if (this.activeName == 3) {
        if (
          this.$route.query.levelId == "-1" ||
          this.$route.query.levelId == null
        ) {
          this.queryData.riskLevelId = -1;
        } else {
          this.queryData.riskLevelId = this.$route.query.levelId;
        }

        this.getList();
      }

      if (this.activeName == 8) {
        this.getDetail()
      }
    },
    changeActiveName(activeName, row, startTime, endTime) {
      this.activeName = activeName;
      this.row = row;
      this.startTime = startTime;
      this.endTime = endTime;
    },
    async getModifyLog(val) {
      this.logLoding = val;
      let userId = this.$route.query.userId;
      try {
        const res = await getModifyLog({ userId: userId, pinFirst: true });
        this.logLoding = false;
        const data = res.data || [];
        let filterIds = [8];
        let resultList = data.filter((a) => {
          return filterIds.some((f) => f == a.type);
        });
        const pinnedData = data.find((item) => item.pin === true);
        if (pinnedData) {
          this.tipsTime = pinnedData.operationTime;
          this.tips = pinnedData.operationAfter;
        } else {
          this.tipsTime = "";
          this.tips = "";
        }
        this.getModifyLogList = resultList || [];
      } catch (error) {
        this.logLoding = false;
      }
    },
    handleRemarkSave() {
      //this.form.remark = this.remark;
      this.handleSave({ remark: this.formRemark.remark }, true);
      this.formRemark.remark = "";
      this.Close();
    },
    handleRemarkReset() {
      this.remark = this.form.remark;
    },
    async handleSave(payload = {}, status = false) {
      const { userId } = this.form;
      if (this.isFetching) {
        // 如果当前正在调用接口，则直接返回
        return;
      }
      this.isFetching = true; // 标记当前正在调用接口
      try {
        const res = await getMemberUpdate({ userId, ...payload });
        if (res.code == 0) {
          this.$message({ message: "update success", type: "success" });
          this.isFetching = false;
          this.getDetail();
        } else {
          this.$message({ message: res.message, type: "warning" });
        }
      } catch (error) {
        this.isFetching = false;
      }
      this.getModifyLog(status);
    },
    openMessageBox(type) {
      let content = "";
      if (type === "selfRisk") {
        content = `Switch SeIf-Risk to ${this.selfRisk === 0 ? "YES" : "NO"}？`;
        this.$confirm(content, "", {
          confirmButtonText: "Yes",
          cancelButtonClass: "cancel-button",
          cancelButtonText: "No",
          type: "warning",
        })
          .then(() => {
            this.form.selfRisk = this.selfRisk === 0 ? 1 : 0;
            this.handleSave({ selfRisk: this.form.selfRisk });
          })
          .catch(() => {});
      } else if(type === "delaySettled"){
        content = `Switch Delay Settle to ${this.delaySettled === 1 ? "NO" : "YES"}？`;
        this.$confirm(content, "", {
          confirmButtonText: "Yes",
          cancelButtonClass: "cancel-button",
          cancelButtonText: "No",
          type: "warning",
        })
          .then(() => {
            this.form.delaySettled = this.delaySettled === 1 ? 0 : 1;
            this.handleSave({ delaySettled: this.form.delaySettled });
          })
          .catch(() => {});
      } else {
        content = `${this.isAlert ? "Close" : "Open"} AIert？`;
        this.$confirm(content, "", {
          confirmButtonText: "Yes",
          cancelButtonClass: "cancel-button",
          cancelButtonText: "No",
          type: "warning",
        })
          .then(() => {
            this.form.isAlert = !this.isAlert;
            this.handleSave({ isAlert: this.form.isAlert });
          })
          .catch(() => {});
      }
    },
  },
  computed: {
    sortedArr() {
      const arrCopy = [...this.riskLevelList];
      arrCopy.sort((a, b) => {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
        // 先将 "Default" 排到最前面
        if (nameA === "DEFAULT") return -1;
        if (nameB === "DEFAULT") return 1;
        // 如果都是 "数字%group" 的形式，则按数字大小升序排列
        const regex = /(\d+)\s*%\s*group/i;
        const matchA = nameA.match(regex);
        const matchB = nameB.match(regex);
        if (matchA && matchB) {
          const numA = parseInt(matchA[1]);
          const numB = parseInt(matchB[1]);
          return numA - numB;
        }
        // 如果都不是 "数字%group" 的形式，则按字典序升序排列
        if (!matchA && !matchB) {
          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        }
        // 如果只有一个是 "数字%group" 的形式，则将不是 "数字%group" 的排在前面
        return matchA ? -1 : 1;
      });
      return arrCopy;
    },
  },
  components: {
    BettingInfo,
    OrderList,
    LoginLog,
    ModifyHistory,
    CheckHistory,
    IPHistory,
    DeviceHistory,
    dia,
    PromotionsDetail,
  },
  mounted() {
    if (this.$route.query.activeName) {
      this.activeName = String(this.$route.query.activeName);
    }
    this.queryData.userId = this.$route.query.userId
      ? this.$route.query.userId
      : "";
    this.queryData.riskLevelId = this.$route.query.levelId;
    this.handleClick();
    this.getLevelList();
    this.getLableList();
    this.getRiskLevel();
    this.oddsDropList();
  },
  activated() {
    this.getDetail();
    this.getBasicInfo();
    this.getModifyLog(true);
  },
};
</script>

<style lang="scss" scoped>
.detail-wrap {
  padding: 15px 20px;
}

/deep/.el-collapse {
  background: #ebedf3;
  border-radius: 5px;
  border: none;
}

/deep/.el-collapse-item__header {
  background: #ebedf3;
  border-radius: 5px;
  padding: 10px 12px;
  border: none;

  .arrow-wrap {
    width: 16px;
    height: 16px;
    background: #2f4162;
    border-radius: 2px;
    position: relative;
    margin-right: 8px;
    top: 7px;

    .arrow {
      position: absolute;
      top: calc(50% - 3.5px);
      left: calc(50% - 5px);
      transition: all 0.3s;
    }
  }

  .title {
    font-weight: 700;
    font-size: 14px;
    margin-right: 22px;
    color: #000;
  }

  .text-wrap {
    display: flex;
    align-items: center;
    margin-right: 27px;
    opacity: 1;
    transition: all 0.3s;
    color: #333333;
  }

  .text-wrap__title {
    font-weight: 700;
    font-size: 12px;
    line-height: 12px;
    padding-right: 2px;
  }

  .text-wrap__content {
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
  }

  .el-collapse-item__arrow {
    display: none;
  }
}

/deep/.el-collapse-item.is-active {
  .arrow {
    transform: rotate(180deg);
  }
  .text-wrap {
    opacity: 0;
  }
}

/deep/.el-collapse-item__content {
  padding-bottom: 10px;
}

/deep/.el-collapse-item__wrap {
  background: #ebedf3;
  border-radius: 5px;
  border: none;
}

.info-row {
  width: calc(100% - 10px);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 0 0 0 10px;
}

.info-row:first-child {
  margin-top: 0px;
}
.remark-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  .tips {
    margin-left: 10px;
    background: #e0bf0d;
    border-radius: 4px;
    padding: 4px 10px;
    font-size: 12px;
    max-width: 950px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    line-height: 20px;
    position: relative;
    top: 10px;
  }
}

.info-row__item {
  flex: 1;
  display: flex;
  align-items: center;
  height: 30px;
  background: #ffffff;
  border-radius: 5px;
  margin-top: 5px;
  margin-right: 10px;
  padding: 10px;

  &.is-clickable {
    cursor: pointer;
  }
  &:last-child {
    margin-right: 0;
  }
}
.item-popover-type {
  display: flex;
  background: #ffffff;
  padding: 4px 0;
  border-radius: 5px;
  margin-top: 4px;
  flex: 1;
  margin-right: 10px;
  height: 30px;
  display: flex;
  align-items: center;
  .info-row__item__title {
    margin-left: 10px;
  }
  .info-row__item__content {
    margin-right: 10px;
  }
  .asc-color {
    line-height: 20px;
    padding-left: 2px;
    border-radius: 4px;
    cursor: pointer;
  }
}
.label-ids {
  display: inline-block;
  background: #00a791;
  border-radius: 2px;
  padding: 4px 6px;
  color: #fff;
  margin-left: 6px;
}
.item-popover-type1 {
  display: flex;
  background: #ffffff;
  padding: 5px 0;
  border-radius: 5px;
  align-items: center;
  flex: 1;
  margin-right: 10px;
  margin-top: 5px;
  .info-row__item__title {
    margin-left: 10px;
  }
  .info-row__item__content {
    margin-right: 10px;
  }
}
.item-popover {
  flex: 1;
  margin-right: 10px;
  .info-row__item {
    flex: none;
  }
  &:last-child {
    margin-right: 0;
  }
}
.item-popover1 {
  .info-row__item {
    flex: none;
  }
}

.info-row__item__title {
  font-weight: 700;
  font-size: 12px;
  line-height: 12px;
  color: #333333;
  margin-right: 4px;
}

.info-row__item__content {
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  color: #333333;
  flex-grow: 1;

  .tag {
    width: fit-content;
    background: #00a791;
    border-radius: 2px;
    padding: 4px 6px;
    color: #fff;
    margin-left: 6px;
  }

  .tag--border {
    background: #fff;
    color: #00a791;
    border: 1px solid #00a791;
  }

  .tag--active {
    background: #4d7812;
  }

  .tag--suspend {
    background: #bc4f2d;
  }

  .tag--block {
    background: #333333;
  }

  .tag-group {
    width: 100%;
    display: flex;
    padding-left: 3px;

    .tag {
      background: #0184b8;
      margin-left: 3px;
    }
  }

  .switch-wrap {
    cursor: pointer;
  }

  .el-switch {
    pointer-events: none;
    margin-left: 4px;
  }

  &.is-text-switch {
    .el-switch {
      position: relative;

      &::after {
        content: "No";
        display: block;
        position: absolute;
        right: 8px;
        color: #fff;
        font-weight: 600;
        font-size: 12px;
        line-height: 14px;
      }

      &.is-checked::after {
        content: "Yes";
        left: 6px;
      }
    }
  }
}

.remark {
  width: 100%;
  background: #ffffff;
  border-radius: 5px;
  padding: 10px;
  margin-top: 5px;
  margin-left: 10px;
  margin-right: -10px;
  position: relative;

  /deep/.el-textarea__inner {
    padding: 10px 0 10px 0;
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    color: #333;
  }
  /deep/.el-input__count {
    bottom: 0;
    right: 0;
  }
}

.remark__title {
  font-weight: 700;
  font-size: 12px;
  line-height: 12px;
  color: #333333;
}

.remark__buttons {
  position: absolute;
  bottom: 6px;

  .el-button {
    width: 38px;
    height: 16px;
  }

  .el-button--primary {
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    color: #ffffff;
    background: #00a791;
    border-radius: 2px;
  }

  .el-button--text {
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    color: #a7b9c7;
  }
}

.el-icon-arrow-down {
  margin-left: 14px;
}

.tab-wrap {
  margin-top: 10px;

  /deep/.el-tabs__nav-wrap {
    background: #ebedf3;
    padding-top: 9px;
    padding-left: 10px;
    border-radius: 5px 5px 0px 0px;
  }

  /deep/.el-tabs--card .el-tabs__nav,
  /deep/.el-tabs--card .el-tabs__nav .el-tabs__item {
    border: none !important;
  }

  /deep/.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    background: #ffffff;
  }

  /deep/.el-tabs__header {
    margin-bottom: 0px !important;
  }
}

.el-popover {
  .el-scrollbar__wrap {
    overflow-x: hidden;
    overflow-y: auto;
    margin-bottom: 10px;
  }

  .el-dropdown-menu__item {
    font-weight: 400;
    font-size: 12px;
    text-align: center;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:hover {
      background: #f5f7fa;
    }

    &.is-selected {
      font-weight: bold;
      color: #00a791;
    }

    &.is-disabled {
      color: #c0c4cc;
      cursor: not-allowed;
      pointer-events: inherit;
    }
  }

  .popover-buttons {
    .el-button {
      width: 62px;
      height: 24px;
    }

    .el-button--primary {
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
      color: #ffffff;
      background: #00a791;
      border-radius: 5px;
    }

    .el-button--text {
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
      color: #999999;
    }
  }
}

.container-content {
  padding: 10px 15px 10px 15px;
  border: 1px solid #ebedf3;
  border-top: none;
  border-radius: 0px 0px 5px 5px;
}
/deep/.risk-table {
  .el-table th {
    padding: 6px 0;
  }
}
.remark-wrapper {
  margin: 0 !important;
}
.odds-tag {
  display: inline-block;
  line-height: 20px;
  text-align: center;
  background: #00a791;
  border-radius: 2px;
  width: 20px;
  height: 20px;
  color: #fff;
}
.overflow-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 200px;
}
</style>
